import { gsap } from "gsap";

const StickyMobileBar = () => {
	const block = document.querySelector(".sticky-mobile-bar");
	if (!block) {
		return;
	}
	let mm = gsap.matchMedia();
	const isDefaultState = block.classList.contains("sticky-mobile-bar_default");

	const handleSticky = () => {
		if (window.scrollY > window.innerHeight / 2) {
			block.classList.add("isSticky");
		} else {
			block.classList.remove("isSticky");
		}
	};

	mm.add("(max-width: 767px)", () => {
		window.addEventListener("scroll", handleSticky, { passive: true });
	});

	mm.add("(min-width: 768px)", () => {
		if (isDefaultState) {
			window.addEventListener("scroll", handleSticky, { passive: true });
		}
	});
};

export default StickyMobileBar;
